<template>
  <div class="">

    <Head />


    <div class="main shiftSchedule">
      <AccesskeyLink target="accesskey_c" accesskey="c" aria-label="跳到中央內容區塊">
        :::
      </AccesskeyLink>

      <!-- 毛毛蟲 -->
      <nav aria-label="breadcrumb" class="breadcrumb_box">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
            <li class="breadcrumb-item"><router-link to="/ScheduleList" :title="$t('排班列表')">{{ $t('排班列表') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('員工排班表') }}</li>
          </ol>
        </div>
      </nav>


      <div class="shiftSchedule_box">

        <div class="container">

          <div class="title_box">
            <h2>{{ scheduleName || $t('員工排班表') }}</h2>
            <p v-if="groupName" class="group-name">{{ groupName }}</p>
          </div>


          <div class="schedule">


            <!-- 圖示說明 -->
            <ul class="iconItems_box">
              <template v-if="!isSubmitted">
                <li>
                  <span class="remaining-label">{{ $t('剩餘需排休假日：') }}</span>
                  <span v-if="remainingRestDays > 0" class="badge badge-primary">{{ remainingRestDays }}</span>
                  <span v-else class="badge badge-secondary">0</span>
                </li>
                <li>
                  <span class="remaining-label">{{ $t('剩餘需排例假日：') }}</span>
                  <span v-if="remainingRegularDaysOff > 0" class="badge badge-primary">{{ remainingRegularDaysOff }}</span>
                  <span v-else class="badge badge-secondary">0</span>
                </li>
              </template>
              <li v-for="(item, index) in iconItems" :key="index">
                <img :src="item.src" :alt="item.title">
                <p>{{ item.title }}</p>
              </li>
            </ul>

            <!-- 排班表 -->
            <div class="schedule_fixed">

              <!-- 左側固定姓名欄 -->
              <div class="name_wrapper">
                <table class="name_table">
                  <thead>
                    <tr>
                      <th class="name">
                        {{ $t('員工姓名') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="user in users" :key="user.csvId">
                      <td class="name">
                        <div class="group">
                          <p>{{ user.name }}</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>

              <!-- 右側日期表格 -->
              <div class="date_wrapper">
                <table class="schedule_table">
                  <thead>
                    <tr>
                      <th v-for="day in daysInPeriod" :key="day.dateStr" :class="day.isHoliday ? 'holiday' : 'weekday'">
                        <div class="day_box">
                          <div>{{ day.day }}</div>
                          <div class="week">（{{ day.weekday }}）</div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="user in users" :key="user.csvId">
                      <td v-for="day in daysInPeriod" :key="day.dateStr" class="date"
                        :class="day.isHoliday ? 'holiday' : 'weekday'">
                        <div class="date_box">
                          <button class="date_btn" :class="{ active: isActive(user.csvId, day.dateStr) }"
                            @click.stop="openPicker(user.csvId, day.dateStr, $event)"
                            :disabled="isSubmitted || user.csvId !== currentUserCsvId">
                            <img v-if="getShiftImg(user.csvId, day.dateStr)"
                              :src="getShiftImg(user.csvId, day.dateStr)" />
                            <img v-else src="img/workdays_green.svg" :alt="$t('可上班日')">
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 班別選擇 Picker -->
              <div v-if="picker.visible && !isSubmitted" class="shift_picker"
                :style="{ top: picker.y + 'px', left: picker.x + 'px' }">
                <div v-for="opt in shiftOptions" :key="opt.id" class="option" @click="selectShift(opt.id)">
                  <img :src="opt.img" />
                  <div>{{ opt.text }}</div>
                </div>
              </div>

            </div>

            <!-- <div class="text_box" v-if="specialLeaveNote">
              <p>
                {{ $t('特休註記') }}
                <br>
                {{ specialLeaveNote }}
              </p>
            </div> -->

            <div class="text_box">
              <p>
                {{ $t('注意事項') }}
                <br>
                {{ $t('*國定假日，不可同時休假。') }}
                <br>
                {{ $t('*如遇天然災害，依本市公佈放假標準為原則。') }}
              </p>
            </div>

            <div class="btn_box">
              <button v-if="!isSubmitted" class="send_btn" @click="saveSchedule">{{ $t('暫存') }}</button>
              <button v-if="!isSubmitted" class="send_btn" @click="submitSchedule">{{ $t('確認送出') }}</button>
            </div>
            <div class="btn_box">
              <button class="send_btn" @click="returnToList">{{ $t('返回列表') }}</button>
            </div>
          </div>




        </div>


      </div>

    </div>

    <Footer />

  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue';
import Swal from 'sweetalert2';

import AccesskeyLink from '@/views/AccesskeyLink.vue'



export default {

  name: 'ShiftSchedule',
  components: {
    Head,
    Footer,

    AccesskeyLink,

  },

  data() {
    return {

      iconItems: [],
      
      shiftOptions: [
        {
          id: 'workday',
          text: '可上班日',
          img: require('/public/img/workdays_green.svg'),
        },
        {
          id: 'restDay',
          text: '休息日(可加班)',
          img: require('/public/img/restDay_bule.svg'),
        },
        {
          id: 'regularDayOff',
          text: '例假日(不可加班)',
          img: require('/public/img/regularDayOff_red.svg'),
        },
        {
          id: 'specialLeave',
          text: '特休',
          img: require('/public/img/star-svgrepo-com.svg'),
        }
      ],

      scheduleName: '',
      groupName: '',
      csId: 0,
      currentUserCsvId: 0,
      currentUserName: '',
      startDate: null,
      endDate: null,
      minRestDays: 0,
      minRegularDaysOff: 0,
      specialLeaveNote: '',
      isSubmitted: false,

      users: [],



      // 排班記錄 格式: { 'csvId_date': 'shiftType' }
      schedules: {},

      picker: {
        visible: false,
        userId: null,
        day: null,
        x: 0,
        y: 0
      },

      isActive(userId, day) {
        return (
          this.picker.visible &&
          this.picker.userId === userId &&
          this.picker.day === day
        )
      },


    }
  },

  async mounted() {
    // 設定iconItems翻譯
    this.iconItems = [
      {
        src: require('/public/img/workdays_green.svg'),
        title: this.$t('可上班日'),
      },
      {
        src: require('/public/img/restDay_bule.svg'),
        title: this.$t('休息日(可加班)'),
      },
      {
        src: require('/public/img/regularDayOff_red.svg'),
        title: this.$t('例假日(不可加班)'),
      },
      {
        src: require('/public/img/star-svgrepo-com.svg'),
        title: this.$t('特休'),
      },
    ]
    
    document.addEventListener('click', this.closePicker)

    // 檢查登入狀態
    const token = sessionStorage.getItem('scheduleToken')
    const csvId = sessionStorage.getItem('scheduleCSVId')
    const name = sessionStorage.getItem('scheduleName')

    if (!token || !csvId) {
      this.$router.push('/ScheduleLogin')
      return
    }

    this.currentUserCsvId = parseInt(csvId)
    this.currentUserName = name

    // 從路由參數取得 csId
    this.csId = parseInt(this.$route.params.csId)
    if (!this.csId) {
      await Swal.fire({
        icon: 'error',
        title: this.$t('錯誤'),
        text: this.$t('無效的排班 ID')
      })
      this.$router.push('/ScheduleList')
      return
    }

    // 載入排班資料
    await this.loadScheduleDetail()

    this.$nextTick(() => {
      this.syncRowHeights()
      window.addEventListener('resize', this.syncRowHeights)

      // 寬度等於表格寬度
      const name = this.$el.querySelector('.name_wrapper')
      const date = this.$el.querySelector('.date_wrapper')
      const container = this.$el.querySelector('.shiftSchedule_box .container')

      if (!name || !date || !container) return

      const totalWidth = name.offsetWidth + date.offsetWidth + 25

      container.style.maxWidth = totalWidth + 'px'
    })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closePicker)
    window.removeEventListener('resize', this.syncRowHeights)
  },

  computed: {
    daysInPeriod() {
      if (!this.startDate || !this.endDate) return []

      const days = []
      const start = new Date(this.startDate)
      const end = new Date(this.endDate)

      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        const dateStr = this.formatDate(d)
        const dayNum = d.getDate()
        const weekday = ['日', '一', '二', '三', '四', '五', '六'][d.getDay()]
        const isHoliday = d.getDay() === 0 || d.getDay() === 6

        days.push({ dateStr, day: dayNum, weekday, isHoliday })
      }

      return days
    },

    remainingRestDays() {
      // 只計算當前登入用戶的休息日數量
      const used = Object.keys(this.schedules).filter(key => {
        const [csvId, date] = key.split('_')
        return parseInt(csvId) === this.currentUserCsvId && this.schedules[key] === 'restDay'
      }).length
      return (this.minRestDays || 0) - used
    },

    remainingRegularDaysOff() {
      // 只計算當前登入用戶的例假日數量
      const used = Object.keys(this.schedules).filter(key => {
        const [csvId, date] = key.split('_')
        return parseInt(csvId) === this.currentUserCsvId && this.schedules[key] === 'regularDayOff'
      }).length
      return (this.minRegularDaysOff || 0) - used
    }
  },

  methods: {

    async loadScheduleDetail() {
      try {
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/GetScheduleDetail`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            csId: this.csId,
            csvId: this.currentUserCsvId
          })
        })

        const result = await response.json()
        if (!result.ok) {
          await Swal.fire({
            icon: 'error',
            title: this.$t('載入失敗'),
            text: result.message || this.$t('載入失敗')
          })
          this.$router.push('/ScheduleList')
          return
        }

        // 設定基本資料
        this.scheduleName = result.scheduling.scheduleName
        this.startDate = result.scheduling.startDate
        this.endDate = result.scheduling.endDate
        this.minRestDays = result.scheduling.minRestDays || 0
        this.minRegularDaysOff = result.scheduling.minRegularDaysOff || 0
        this.specialLeaveNote = result.scheduling.specialLeaveNote || ''
        this.groupName = result.groupName || ''
        this.isSubmitted = result.isSubmitted

        // 建立使用者列表 (登入者排第一位)
        const currentUser = {
          csvId: result.staffVolunteer.csvId,
          name: result.staffVolunteer.name,
          isSubmitted: result.isSubmitted
        }

        const otherUsers = result.allStaffSchedules
          .filter(staff => staff.csvId !== this.currentUserCsvId)
          .map(staff => ({
            csvId: staff.csvId,
            name: staff.name,
            isSubmitted: staff.isSubmitted
          }))

        this.users = [currentUser, ...otherUsers]

        // 載入我的排班記錄
        result.mySchedules.forEach(schedule => {
          const formattedDate = this.formatDate(schedule.scheduleDate)
          const key = `${this.currentUserCsvId}_${formattedDate}`
          this.$set(this.schedules, key, schedule.shiftType)
        })

        // 載入其他員工的排班記錄
        if (result.allStaffSchedules) {
          result.allStaffSchedules.forEach(staff => {
            staff.schedules.forEach(schedule => {
              const formattedDate = this.formatDate(schedule.scheduleDate)
              const key = `${staff.csvId}_${formattedDate}`
              this.$set(this.schedules, key, schedule.shiftType)
            })
          })
        }

      } catch (error) {
        console.error('載入排班資料失敗:', error)
        await Swal.fire({
          icon: 'error',
          title: this.$t('載入失敗'),
          text: this.$t('載入排班資料失敗，請稍後再試')
        })
        this.$router.push('/ScheduleList')
      }
    },

    async saveSchedule() {
      try {
        // 收集我的排班記錄（只儲存休息日和例假日，不儲存可上班日）
        const mySchedules = []
        Object.keys(this.schedules).forEach(key => {
          const [csvId, date] = key.split('_')
          if (parseInt(csvId) === this.currentUserCsvId) {
            const shiftType = this.schedules[key]
            // 儲存非可上班日的班別
            if (shiftType !== 'workday') {
              mySchedules.push({
                scheduleDate: date,
                shiftType: shiftType
              })
            }
          }
        })

        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/SaveSchedule`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            csId: this.csId,
            csvId: this.currentUserCsvId,
            schedules: mySchedules
          })
        })

        const result = await response.json()
        if (result.ok) {
          await Swal.fire({
            icon: 'success',
            title: this.$t('暫存成功'),
            showConfirmButton: false,
            timer: 1500
          })
        } else {
          await Swal.fire({
            icon: 'error',
            title: this.$t('暫存失敗'),
            text: result.message || this.$t('暫存失敗')
          })
        }

      } catch (error) {
        console.error('暫存失敗:', error)
        await Swal.fire({
          icon: 'error',
          title: this.$t('暫存失敗'),
          text: this.$t('送出失敗，請稍後再試')
        })
      }
    },

    async submitSchedule() {
      // 驗證休息日和例假日數量
      if (this.remainingRestDays < 0) {
        await Swal.fire({
          icon: 'warning',
          title: this.$t('休息日超過限制'),
          text: `${this.$t('休息日超過限制')}，${this.$t('請移除')} ${Math.abs(this.remainingRestDays)} ${this.$t('天')}`
        })
        return
      }
      if (this.remainingRestDays > 0) {
        await Swal.fire({
          icon: 'warning',
          title: this.$t('休息日不足'),
          text: `${this.$t('休息日不足')}，${this.$t('還需要選擇')} ${this.remainingRestDays} ${this.$t('天')}`
        })
        return
      }
      if (this.remainingRegularDaysOff < 0) {
        await Swal.fire({
          icon: 'warning',
          title: this.$t('例假日超過限制'),
          text: `${this.$t('例假日超過限制')}，${this.$t('請移除')} ${Math.abs(this.remainingRegularDaysOff)} ${this.$t('天')}`
        })
        return
      }
      if (this.remainingRegularDaysOff > 0) {
        await Swal.fire({
          icon: 'warning',
          title: this.$t('例假日不足'),
          text: `${this.$t('例假日不足')}，${this.$t('還需要選擇')} ${this.remainingRegularDaysOff} ${this.$t('天')}`
        })
        return
      }

      const result = await Swal.fire({
        icon: 'question',
        title: this.$t('確認送出'),
        text: this.$t('確定要送出排班嗎？送出後將無法修改'),
        showCancelButton: true,
        confirmButtonText: this.$t('確定送出'),
        cancelButtonText: this.$t('取消'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      })
      
      if (!result.isConfirmed) {
        return
      }

      try {
        // 送出前先儲存排班資料
        const mySchedules = []
        Object.keys(this.schedules).forEach(key => {
          const [csvId, date] = key.split('_')
          if (parseInt(csvId) === this.currentUserCsvId) {
            const shiftType = this.schedules[key]
            // 儲存非可上班日的班別
            if (shiftType !== 'workday') {
              mySchedules.push({
                scheduleDate: date,
                shiftType: shiftType
              })
            }
          }
        })

        // 先呼叫 SaveSchedule API
        const saveApiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/SaveSchedule`;
        const saveResponse = await fetch(saveApiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            csId: this.csId,
            csvId: this.currentUserCsvId,
            schedules: mySchedules
          })
        })

        const saveResult = await saveResponse.json()
        if (!saveResult.ok) {
          await Swal.fire({
            icon: 'error',
            title: this.$t('儲存失敗'),
            text: saveResult.message || this.$t('儲存排班資料失敗')
          })
          return
        }

        // 儲存成功後，再呼叫 SubmitSchedule API
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/SubmitSchedule`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            csId: this.csId,
            csvId: this.currentUserCsvId
          })
        })

        const submitResult = await response.json()
        if (submitResult.ok) {
          await Swal.fire({
            icon: 'success',
            title: this.$t('送出成功'),
            text: this.$t('您的排班已成功送出'),
            showConfirmButton: false,
            timer: 2000
          })
          this.isSubmitted = true
        } else {
          await Swal.fire({
            icon: 'error',
            title: this.$t('送出失敗'),
            text: submitResult.message || this.$t('送出失敗')
          })
        }

      } catch (error) {
        console.error('送出失敗:', error)
        await Swal.fire({
          icon: 'error',
          title: this.$t('送出失敗'),
          text: this.$t('送出失敗，請稍後再試')
        })
      }
    },

    returnToList() {
      this.$router.push('/ScheduleList')
    },

    // 班別 picker
    openPicker(userId, day, event) {
      if (this.isSubmitted || userId !== this.currentUserCsvId) return
      this.picker = { visible: true, userId, day, x: event.clientX, y: event.clientY }
    },
    async selectShift(shiftId) {
      const key = `${this.picker.userId}_${this.picker.day}`
      const currentShiftId = this.schedules[key] // 當前格子的班別
      
      // 檢查是否試圖選擇休息日或例假日
      if (shiftId === 'restDay' || shiftId === 'regularDayOff') {
        // 計算當前登入用戶已選擇的數量（排除目前要修改的這個格子）
        let currentRestDays = 0
        let currentRegularDaysOff = 0
        
        Object.keys(this.schedules).forEach(k => {
          if (k !== key) { // 排除當前格子
            const [csvId, date] = k.split('_')
            // 只計算當前登入用戶的記錄
            if (parseInt(csvId) === this.currentUserCsvId) {
              if (this.schedules[k] === 'restDay') currentRestDays++
              if (this.schedules[k] === 'regularDayOff') currentRegularDaysOff++
            }
          }
        })
        
        // 檢查休息日是否已達上限
        if (shiftId === 'restDay' && currentRestDays >= this.minRestDays) {
          this.picker.visible = false
          await Swal.fire({
            icon: 'warning',
            title: this.$t('已達上限'),
            text: `${this.$t('休息日已達上限')} ${this.minRestDays} ${this.$t('天')}，${this.$t('無法再新增')}`
          })
          return
        }
        
        // 檢查例假日是否已達上限
        if (shiftId === 'regularDayOff' && currentRegularDaysOff >= this.minRegularDaysOff) {
          this.picker.visible = false
          await Swal.fire({
            icon: 'warning',
            title: this.$t('已達上限'),
            text: `${this.$t('例假日已達上限')} ${this.minRegularDaysOff} ${this.$t('天')}，${this.$t('無法再新增')}`
          })
          return
        }
      }
      
      this.$set(this.schedules, key, shiftId)
      this.picker.visible = false
      this.$nextTick(this.syncRowHeights)
    },
    getShiftImg(userId, day) {
      const key = `${userId}_${day}`
      const shiftId = this.schedules[key]
      const opt = this.shiftOptions.find(o => o.id === shiftId)
      return opt ? opt.img : null
    },
    formatDate(date) {
      const d = typeof date === 'string' ? new Date(date) : date
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },

    closePicker() { this.picker.visible = false },

    // 同步左右表格行高
    syncRowHeights() {
      this.$nextTick(() => {
        const nameRows = this.$el.querySelectorAll('.name_table tbody tr')
        const scheduleRows = this.$el.querySelectorAll('.schedule_table tbody tr')
        nameRows.forEach((row, i) => {
          const scheduleRow = scheduleRows[i]
          if (scheduleRow) {
            const maxHeight = Math.max(row.offsetHeight, scheduleRow.offsetHeight)
            row.style.height = maxHeight + 'px'
            scheduleRow.style.height = maxHeight + 'px'
          }
        })
        const nameHead = this.$el.querySelector('.name_table thead tr')
        const scheduleHead = this.$el.querySelector('.schedule_table thead tr')
        if (nameHead && scheduleHead) {
          const maxHeadHeight = Math.max(nameHead.offsetHeight, scheduleHead.offsetHeight)
          nameHead.style.height = maxHeadHeight + 'px'
          scheduleHead.style.height = maxHeadHeight + 'px'
        }
      })
    },
  }
}

</script>

<style scoped>
.remaining-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 8px;
}

.remaining-label {
  font-weight: bold;
  margin-right: 8px;
}

.badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: bold;
}

.badge-primary {
  background-color: #007bff;
  color: white;
}

.badge-secondary {
  background-color: #6c757d;
  color: white;
}
</style>
